import {
  Action,
  ActionType,
  ScheduleFilterDatasResponse,
} from "models/vaccine/schedules";
import createReducer from "../../createReducer";

export interface ScheduleFilterDatasReducerType {
  loading: boolean;
  error?: string;
  scheduleFilterResponse?: ScheduleFilterDatasResponse;
}

const defaultState: ScheduleFilterDatasReducerType = {
  loading: false,
  error: undefined,
  scheduleFilterResponse: undefined,
};

export const scheduleFilterReducer =
  createReducer<ScheduleFilterDatasReducerType>(defaultState, {
    [ActionType.SCHEDULE_FILTER](state: ScheduleFilterDatasReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.SCHEDULE_FILTER_ERROR](
      state: ScheduleFilterDatasReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.SCHEDULE_FILTER_SUCCESS](
      state: ScheduleFilterDatasReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        scheduleFilterResponse: action.payload,
      };
    },
  });
